import MainApi from "../../MainApi";
import { most_reviewed_items_api} from "../../ApiRoutes";
import {useQuery} from "react-query";
import {onErrorResponse} from "../../api-error-response/ErrorResponses";

const getData = async (pageParams) => {
    const {type} = pageParams
    const { data } = await MainApi.get(`${most_reviewed_items_api}?type=${type}`)
    return data
}

export default function useGetMostReviewed(pageParams) {
    const moduleId = typeof window !== "undefined" ? JSON.parse(localStorage.getItem("module"))?.id : null;
    return useQuery(['best-reviewed-items', moduleId],()=> getData(pageParams),{
        enabled:false,
        onError:onErrorResponse,
    })
}